import React from 'react';
import ConditionEdge from './ConditionEdge';

// 导出所有边类型组件
export default {
    ConditionEdge,
};
